import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
    static targets = ["slide", "dot"];

    initialize() {
        this.currentIndex = 0;
    }

    connect() {
        this.updateDisplay();
    }

    previous() {
        if (this.currentIndex > 0) {
            this.currentIndex--;
        } else {
            this.currentIndex = this.slideTargets.length - 1;
        }
        this.updateDisplay();
    }

    next() {
        if (this.currentIndex < this.slideTargets.length - 1) {
            this.currentIndex++;
        } else {
            this.currentIndex = 0;
        }
        this.updateDisplay();
    }

    goTo(event) {
        const index = parseInt(event.params.index, 10);
        if (!isNaN(index)) {
            this.currentIndex = index;
            this.updateDisplay();
        }
    }

    updateDisplay() {
        this.slideTargets.forEach((element, index) => {
            element.style.display = index === this.currentIndex ? "block" : "none";
        });
        this.dotTargets.forEach((element, index) => {
            if (index === this.currentIndex) {
                element.classList.add("opacity-100");
                element.classList.remove("opacity-[.32]");
            } else {
                element.classList.remove("opacity-100");
                element.classList.add("opacity-[.32]");
            }
        });
    }
}
